import { render, staticRenderFns } from "./ScanQRHeader.vue?vue&type=template&id=35fc31f8&"
import script from "./ScanQRHeader.vue?vue&type=script&lang=ts&"
export * from "./ScanQRHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports